// TODO: Review AI Code for feature: Process Map - Entire file is AI-generated
import { ListProcessChainsRequestSchema, ListProcessChainsResponseSchema } from './list-process-chains.schema';
// TODO: Review AI Code for feature: Process Map - Entire file is AI-generated
export const listProcessChainsContract = {
    method: 'GET',
    path: '/api/v2/process-chains',
    description: 'List process chains with optional category/parent filter',
    requestSchema: ListProcessChainsRequestSchema,
    responseSchema: ListProcessChainsResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized',
            403: 'Forbidden'
        }
    }
};

//# sourceMappingURL=list-process-chains.contract.js.map